import React, { useMemo } from "react";
import "./TeamCultureSection4.scss";
import right_arrow from "../../assets/image/team-culture-section-2/right_arrow.png";
import useTranslationCustom from "../../assets/image/community-section-1/useTranslationCustom";
import { Link } from "react-router-dom";
import useScrollAnimation from "../../module/animation/useScrollAnimation";

function TeamCultureSection4() {
  const { t, i18n } = useTranslationCustom({
    prefix: "section_4",
    nameSpace: "team_culture",
  });
  useScrollAnimation(["team-culture-section-4"]);

  return (
    <div className={"team-culture-section-4"}>
      <h1>{t("title")}</h1>
      <Link to={"/employment/recruit"} className="team-culture-section-4-link">
        {t("button")}
        <img src={right_arrow} alt="" />
      </Link>
    </div>
  );
}

export default TeamCultureSection4;
